import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  public url: string;
  public token;
  public headers: HttpHeaders;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));
    
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  new(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/new?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  newBulk(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/newbulk?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  update(token, id, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/edit/${id}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  unlockReport(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/report/unlock/${id}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  getPIByPO(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/report/getpibypo/${id}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  list(token, page = null, task): Observable<any> {
    if (page == null) {
      page = 1;
    }
    if (task.status === 'ALL' && task.type === 'ALL') {
      console.log('holi uno');
      let params = `authorization=${token}`;
      let headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      });
      return this._http.post<any>(`${this.url}/report/list?page=${page}`, params, { headers: headers })
        .pipe(map(res => res));
    } else {
      console.log('holi dos');
      let json = JSON.stringify(task);
      json = encodeURIComponent(json);

      let params = `json=${json}&authorization=${token}`;
      let headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      });
      return this._http.post<any>(`${this.url}/report/listbytype?page=${page}`, params, { headers: headers })
        .pipe(map(res => res));
    }
  }

  listNew(page = 1, perPage = 10, busqueda = "", filtros = []) {

    let url = GLOBAL.url + "/report/listnew?";

    let json = null;
    if (busqueda !== "") {
      json = {
        busqueda: busqueda,
      };
    }

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(
      url,
      json
    );
  }

  search(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/search`, params, { headers: headers })
      .pipe(map(res => res));
  }

  searchSecuraze(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/searchsecuraze`, params, { headers: headers })
      .pipe(map(res => res));
  }

  listType(token, page = null, type): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/list/${type}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  getReport(token, id, page = null): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/detail/${id}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  getEPSSZE(token, id, task): Observable<any> {

    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/hdreport/searchepssze/${id}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  getReportByPo(token, id, page = null, type = null): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ type }));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/detailbypo/${id}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  getDiscs(token, report_id, page, perpage): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/list/${report_id}?page=${page}&perpage=${perpage}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  removeDiscs(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/remove/${id}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  removeDiscsBulk(token, id_report, json_hd): Observable<any> {
    let task = { report_id: id_report, data: json_hd };
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/removediscsbulk`, params, { headers: headers })
      .pipe(map(res => res));
  }

  enviarDisco(token, id_report, json_hd): Observable<any> {
    let task = { report_id: id_report, data: json_hd };
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/new`, params, { headers: headers })
      .pipe(map(res => res));
  }

  enviarDiscoBulkReport(token, id_report, json_hd): Observable<any> {
    let task = { report_id: id_report, data: json_hd };
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/newbulkreport`, params, { headers: headers })
      .pipe(map(res => res));
  }

  enviarDiscoBulk(token, id_report, json_hd): Observable<any> {
    let task = { report_id: id_report, data: json_hd };
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/newbulk`, params, { headers: headers })
      .pipe(map(res => res));
  }

  borrarDiscoBulk(token, id_report, json_hd): Observable<any> {
    let task = { report_id: id_report, data: json_hd };
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/hdreport/removebulk`, params, { headers: headers })
      .pipe(map(res => res));
  }

  remove(token, id, page = null): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/remove/${id}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  reportShippedSummary(token, task): Observable<any> {
    let params;
    let headers;
    let json = JSON.stringify(task);

    json = encodeURIComponent(json);
    params = `json=${json}&authorization=${token}`;
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/report/reportshippedsummary?page=1`, params, { headers: headers })
      .pipe(map(res => res));
  }

  getShippedReuse(token, id, page = null): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/shippedsummarydetail/${id}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  editShippedReuse(token, id, shipped): Observable<any> {
    let json = JSON.stringify(shipped);
    json = encodeURIComponent(json);
    console.log(json);
    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/editshippedreuse/${id}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  checkPOReport(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/report/checkporeport`, params, { headers: headers })
      .pipe(map(res => res));
  }

  vendorReview(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);

    let params = `json=${json}&authorization=${token}`;

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post<any>(`${this.url}/report/vendor-review?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }
}
